import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces([
  'common',
  'contact',
  'home',
  'navigation',
  'process',
]);

export type ProcessConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};

export const processConfig: ProcessConfig = {
  i18nNamespaces,
};
